// import { registerExpressPaymentMethod } from '@woocommerce/blocks-registry';
import { registerPaymentMethod } from "@woocommerce/blocks-registry";
import { createElement, useEffect, Fragment } from "@wordpress/element";
import { __ } from "@wordpress/i18n";
import MethodDescription, {declOfNum} from "./selectPart"; // Импортируем новый компонент
import "./styles.scss";



// Получаем функцию для регистрации платёжного метода.

// const config = saphaliSettingsMonoBank;
const monobank_data = {
  ...window.wc.wcSettings.getSetting("monobank_data"),
  hold: window.wc.wcSettings.getSetting("monobank_data").hold === "yes",
  partforclientmono:
    window.wc.wcSettings.getSetting("monobank_data").partforclientmono ===
    "yes",
};
const MonoPaymentMethodContent = (props) => {
  const { billing } = props;
  // console.log("MonoPaymentMethodContent", props);
  
  return (
    <MethodDescription billing={billing} monobank_data={monobank_data} eventRegistration={props.eventRegistration} emitResponse={props.emitResponse} />
  );
};



const formatCurrency = (amount, currency) => {
  const {
    thousandSeparator = "",
    decimalSeparator = ".",
    minorUnit = 2,
    prefix = "",
    suffix = "",
  } = currency;

  const formattedAmount = (amount / 10 ** minorUnit).toFixed(minorUnit);
  return `${prefix}${formattedAmount.replace(".", decimalSeparator)}${suffix}`;
};

const method_description = (billing, description = "") => {
  let partsCount = monobank_data.partsCount;
  let maxPartsCount = monobank_data.partsCount;
  let selectedPartsCount = partsCount;
  const total = billing?.cartTotal?.value ?? jQuery('');
  const currency = billing?.currency ?? {
    code: "UAH",
    symbol: "грн.",
    thousandSeparator: "",
    decimalSeparator: ".",
    minorUnit: 2,
    prefix: "",
    suffix: " грн.",
  };

  // Проверяем, если есть сохранённые настройки количества платежей
  if (monobank_data.partforclientmono && monobank_data.partsCount > 2) {
    selectedPartsCount =
      monobank_data.savedPartforclientmono &&
      monobank_data.savedPartforclientmono > 1
        ? monobank_data.savedPartforclientmono
        : partsCount;
  }

  return (
    <div className="method_description_part">
      {/* Блок выбора предпочитаемого типа оплаты, если есть разные варианты */}
      {monobank_data.merchantTypeMonoName && (
        <fieldset className="form-group" style={{ marginBottom: "10px" }}>
          <legend>
            {__("Выберите предпочитаемый тип", "themewoocommerce-monobank")}
          </legend>
          <select name="merchantTypeMono">
            {Object.entries(monobank_data.merchantTypeMonoName).map(
              ([key, value]) => (
                <option key={key} value={key}>
                  {value}
                </option>
              )
            )}
          </select>
        </fieldset>
      )}

      {/* Блок выбора количества платежей */}
      {monobank_data.partforclientmono &&
        (partsCount > 2 || maxPartsCount > 2) && (
          <div>
            <div className="main_block_part">
              {__("Количество платежей", "themewoocommerce-monobank")}{" "}
              <span className="partforclientmono_max">
                ({__("максимально", "themewoocommerce-monobank")}{" "}
                {declOfNum(monobank_data.partsCount, [
                  __("платеж", "themewoocommerce-monobank"),
                  __("платежа", "themewoocommerce-monobank"),
                  __("платежей", "themewoocommerce-monobank"),
                ])}
                )
              </span>
              :
              <select
                name="partforclientmono"
                className="partforclientmono"
                defaultValue={selectedPartsCount}>
                {Array.from(
                  { length: monobank_data.partsCount - 1 },
                  (_, i) => i + 2
                ).map((num) => (
                  <option key={num} value={num}>
                    {declOfNum(num, [
                      __("платеж", "themewoocommerce-monobank"),
                      __("платежа", "themewoocommerce-monobank"),
                      __("платежей", "themewoocommerce-monobank"),
                    ])}{" "}
                    - {Math.round(total / num, 2)/100}
                  </option>
                ))}
              </select>
            </div>
            <span className="partforclientmono_text d-none">
              {declOfNum(selectedPartsCount, [
                __("платеж", "themewoocommerce-monobank"),
                __("платежа", "themewoocommerce-monobank"),
                __("платежей", "themewoocommerce-monobank"),
              ])}{" "}
              по {total}
            </span>
          </div>
        )}

      <hr style={{ width: "auto" }} />
    </div>
  );
};

/**
 * Компонент, отвечающий за вывод ярлыка (label) платежного метода.
 */
const MonoPaymentMethodLabel = () => {
  return <div className="mono-payment-method-label">{monobank_data.title}</div>;
  //   createElement(
  //     "div",
  //     { className: "mono-payment-method-label" },
  //     monobank_data.title
  //   )
};

/**
 * Компонент, который будет отображён в зоне оплаты на фронтенде.
 * Здесь мы выводим кнопку, стилизованную в соответствии с переданными параметрами.
 */
const MonoPaymentMethodContent2 = (props) => {
  // buttonAttributes могут быть заданы через настройки магазина (например, высота, borderRadius)
  // console.log("MonoPaymentMethodContent", props);

  const {
    buttonAttributes,
    onClick,
    activePaymentMethod,
    paymentStatus,
    billing,
  } = props;
  const height =
    buttonAttributes && buttonAttributes.height
      ? `${buttonAttributes.height}px`
      : "48px";
  const borderRadius =
    buttonAttributes && buttonAttributes.borderRadius
      ? `${buttonAttributes.borderRadius}px`
      : "4px";

  const style = {
    height,
    borderRadius,
    padding: "0 16px",
    backgroundColor: "#007cba",
    color: "#fff",
    border: "none",
    cursor: "pointer",
  };
  //   return createElement(
  //     "button",
  //     {
  //       style,
  //       onClick,
  //       className: "mono-payment-method-button",
  //     },
  //     "Оплатить через MonoBank"
  //   );
  return (
    <>
      {method_description(billing)}
      <button
        style={style}
        onClick={onClick}
        className="mono-payment-method-button">
        {__("Оплатить через MonoBank", "themewoocommerce-monobank")}
      </button>
    </>
  );
};

/**
 * Компонент для отображения в редакторе (админском интерфейсе блока).
 * Он позволяет показать предпросмотр для мерчанта.
 */
const MonoPaymentMethodEdit = () => {
  return createElement(
    "div",
    { className: "mono-payment-method-edit" },
    "MonoBank (редактирование)"
  );
};

/**
 * Функция, определяющая, доступен ли данный платёжный метод для покупателя.
 * Здесь можно добавить любые проверки (например, по составу корзины или странам доставки).
 * Для простоты в примере всегда возвращаем true.
 */
const canMakeMonoPayment = () => {
  // console.log("canMakeMonoPayment", props);
  // Можно использовать переданные объекты для сложной логики
  // if(cartTotals.total > config.monobank.minOrderAmount) {
  // console.log("cartTotals", cartTotals.total_items, monobank_data);

  // if (
  //   cartTotals.total_items <
  //   500 / (monobank_data.kurs ?? 1) /* config.monobank.minOrderAmount */
  // ) {
  //   return false;
  // }

  return true;
};

/**
 * Конфигурация платежного метода для клиентской стороны.
 * Обратите внимание, что:
 * - name и paymentMethodId должны совпадать и быть уникальными.
 * - gatewayId – идентификатор платежного шлюза, зарегистрированного на сервере.
 * - label, content, edit – React-элементы (созданные через wp.element.createElement или JSX, если у вас настроен сборщик).
 */
const monoPaymentMethodOptions = {
  name: "monobank",
  title: monobank_data.title,
  description: monobank_data.description,
  gatewayId: "monobank", // идентификатор, который должен быть зарегистрирован на серверной стороне
  label: createElement(MonoPaymentMethodLabel),
  ariaLabel: __("Оплатить через MonoBank", "themewoocommerce-monobank"),
  content: createElement(MonoPaymentMethodContent),
  placeOrderButtonLabel: __(
    "Оформить оплату частями через MonoBank",
    "themewoocommerce-monobank"
  ),
  edit: createElement(MonoPaymentMethodEdit),
  canMakePayment: canMakeMonoPayment,
  paymentMethodId: "monobank",
  supports: {
    features: ["products"], // можно добавить другие возможности, если требуется
    style: ["height", "borderRadius"],
  },
};

// Регистрируем express-платёжный метод.
// registerExpressPaymentMethod( monoPaymentMethodOptions );
registerPaymentMethod(monoPaymentMethodOptions);

// Если требуется регистрация обычного платежного метода (не express),
// то можно использовать registerPaymentMethod, например:
// const { registerPaymentMethod } = wc.wcBlocksRegistry;
// registerPaymentMethod( monoPaymentMethodOptions );
